import { render } from "./ShopUser.vue?vue&type=template&id=2054fe9d&scoped=true&ts=true"
import script from "./ShopUser.vue?vue&type=script&lang=ts"
export * from "./ShopUser.vue?vue&type=script&lang=ts"

import "./ShopUser.vue?vue&type=style&index=0&id=2054fe9d&lang=stylus&scoped=true"
import "./ShopUser.vue?vue&type=style&index=1&id=2054fe9d&lang=stylus"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2054fe9d"]])

export default __exports__